import {
  SOCIAL_LINKS as socialLinks,
  COMMON_IMAGES as commonImages,
  FEATURED_IMAGES as featuredImages,
} from './constants';
import { IMAGE_DATABASE as imgDb } from './imgDb';

export const SOCIAL_LINKS = socialLinks;
export const COMMON_IMAGES = commonImages;
export const FEATURED_IMAGES = featuredImages;
export const IMAGE_DATABASE = imgDb;
